// src/components/Configurator/hooks/useUIState.js
import { useState, useCallback } from 'react';

export const useUIState = () => {
    const [isTemplatePanelOpen, setIsTemplatePanelOpen] = useState(false);
    // --- ИЗМЕНЕНО НАЗВАНИЕ ---
    const [activePlacementSlot, setActivePlacementSlot] = useState(null);
    const [contextMenu, setContextMenu] = useState(null);
    const [elementTypeToPlace, setElementTypeToPlace] = useState(null);
    const [isPlacementModeActive, setIsPlacementModeActive] = useState(false);
    const [placementSlots, setPlacementSlots] = useState([]);
    const [isHistoryPanelOpen, setIsHistoryPanelOpen] = useState(false);

    const closeContextMenu = useCallback(() => setContextMenu(null), []);
    
    const exitPlacementMode = useCallback(() => {
        setIsPlacementModeActive(false);
        setPlacementSlots([]);
    }, []);

    return {
        isTemplatePanelOpen,
        setIsTemplatePanelOpen,
        // --- ИЗМЕНЕНО НАЗВАНИЕ ---
        activePlacementSlot,
        setActivePlacementSlot,
        contextMenu,
        setContextMenu,
        elementTypeToPlace,
        setElementTypeToPlace,
        closeContextMenu,
        isPlacementModeActive,
        setIsPlacementModeActive,
        placementSlots,
        setPlacementSlots,
        exitPlacementMode,
        isHistoryPanelOpen,
        setIsHistoryPanelOpen,
    };
};